import { useMediaQuery } from 'hooks';
import { SectionContainer, Button, ButtonSize } from 'ui';
import { sectionContainer, screenTablet, positionLeft, positionRight } from './peer-groups.module.scss';
import { Circle } from 'ui/circle';

export const PeerGroups = () => {
    const isTablet = useMediaQuery(`(min-width: ${screenTablet})`);

    return (
        <SectionContainer className={sectionContainer}>
            {!isTablet ? (
                ''
            ) : (
                <>
                    {' '}
                    <Circle position={positionLeft} />
                    <Circle position={positionRight} />
                </>
            )}

            <h3>Create peer groups</h3>
            <p>
                Share projects and content with friends and colleagues. Collaborate with your peer groups. Give and take
                for great content.
            </p>
            <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                <Button text="Try it now" size={ButtonSize.Medium} />
            </a>
        </SectionContainer>
    );
};
